export * from './route.service';
export * from './route.interface';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/core/route/index.ts